import { render, staticRenderFns } from "./v_Admin_Manage_Quests.vue?vue&type=template&id=0b8a2d7c&scoped=true&"
import script from "./v_Admin_Manage_Quests.vue?vue&type=script&lang=js&"
export * from "./v_Admin_Manage_Quests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8a2d7c",
  null
  
)

export default component.exports